import type { IconNode } from '../types';

/**
 * @name garlic
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgNGEyIDIgMCAwIDAtMi0yaC0yYTIgMiAwIDAgMC0yIDJ2MWMwIDEtLjUgMi0xLjQgMi41TDUuMSA5LjFBNyA3IDAgMCAwIDkgMjJoNmE3IDcgMCAwIDAgMy44LTEyLjhsLTIuNS0xLjZBMy4zMiAzLjMyIDAgMCAxIDE1IDVaIiAvPgogIDxwYXRoIGQ9Ik05IDVjMCA0LTIgNC0yIDkgMCA0LjQgMi4yIDggNSA4czUtMy42IDUtOGMwLTUtMi01LTItOSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/garlic
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const garlic: IconNode = [
  [
    'path',
    {
      d: 'M15 4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1c0 1-.5 2-1.4 2.5L5.1 9.1A7 7 0 0 0 9 22h6a7 7 0 0 0 3.8-12.8l-2.5-1.6A3.32 3.32 0 0 1 15 5Z',
      key: '2lunr2',
    },
  ],
  ['path', { d: 'M9 5c0 4-2 4-2 9 0 4.4 2.2 8 5 8s5-3.6 5-8c0-5-2-5-2-9', key: '1bvg3l' }],
];

export default garlic;
